import React, {useEffect, useState} from "react";
import RequestHelper from "src/Lib/Helper/RequestHelper";
import {toast} from "react-toastify";

const LocationSelector = ({
    labelClass= "block font-14 text-gray-700 mb-1 mt-4",
    inputClass= "bg-light w-full font-14 p-2 rounded-xl border",
                              params,
                              setParams
                          }) => {
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [loader, setLoader] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            setLoader(true);
            try {
                const countriesRes = await RequestHelper.get("NPAN_METABRO_MNGR", "/dyna/Country", {populates: "country_language-country_currency-country_states_cities"});

                if (countriesRes.success) {
                    setCountries(countriesRes.object);
                } else {
                    toast.error("Failed to fetch data for dropdowns.");
                }
            } catch (error) {
                toast.error("An error occurred while loading data.");
            }
            setLoader(false);
        };

        fetchData();
    }, []);

    useEffect(() => {
        if(params.countryId) {
            const selectedCountry = countries.find((country) => country._id === params.countryId);
            const states = selectedCountry?.states || [];

            const selectedState = states.find((state) => state._id === params.stateId);
            const cities = selectedState?.cities || [];
            setTimeout(() => {
                setStates(states);
                setCities(cities);
            })
        }

    }, [countries])

    const handleCountryChange = (event) => {
        const selectedCountryId = event.target.value;
        const selectedCountry = countries.find((country) => country._id === selectedCountryId);

        setParams({
            ...params,
            country: selectedCountry?.name || "",
            countryId: selectedCountryId,
            state: "",
            city: "",
            cityId: "",
        });

        setStates(selectedCountry?.states || []);
        setCities([]);
    };

    const handleStateChange = (event) => {
        const selectedStateId = event.target.value;
        const selectedState = states.find((state) => state._id === selectedStateId);

        setParams({
            ...params,
            state: selectedState?.name || "",
            stateId: selectedStateId,
            city: "",
            cityId: "",
        });

        setCities(selectedState?.cities || []);
    };

    const handleCityChange = (event) => {
        const selectedCityId = event.target.value;
        const selectedCity = cities.find((city) => city._id === selectedCityId);

        setParams({
            ...params,
            city: selectedCity?.name || "",
            cityId: selectedCityId,
        });
    };
    return (
        <>
            <label className={labelClass}>Country:</label>
            <select
                name="country"
                value={params.countryId || ''}
                onChange={handleCountryChange}
                required
                className={inputClass}
            >
                <option value="">Select</option>
                {countries.map((country) => (
                    <option key={country._id} value={country._id}>
                        {country.name}
                    </option>
                ))}
            </select>

            <label className={labelClass}>State:</label>
            <select
                name="state"
                value={params.stateId || ''}
                onChange={handleStateChange}
                required
                disabled={!params.countryId}
                className={inputClass}
            >
                <option value="">Select</option>
                {states.map((state) => (
                    <option key={state._id} value={state._id}>
                        {state.name}
                    </option>
                ))}
            </select>

            <label className={labelClass}>City:</label>
            <select
                name="city"
                value={params.cityId || ''}
                onChange={handleCityChange}
                required
                disabled={!params.stateId}
                className={inputClass}
            >
                <option value="">Select</option>
                {cities.map((city) => (
                    <option key={city._id} value={city._id}>
                        {city.name}
                    </option>
                ))}
            </select>
        </>
    );
};

export default LocationSelector;
